import React, { Component } from 'react';

import Helmet from './Helmet';

const Title = 'Embed a Canny widget into your mobile app';
const Description =
  'Our mobile widget lets your users post & vote on feedback from within your mobile app.';
const Image = 'https://canny.io/images/canny-social.png';

export default class WidgetDocsMobileHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: 'https://developers.canny.io/install/widget/mobile' },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}
      />
    );
  }
}
